import { escape } from 'lodash';

export const processPastedTextToArray = (pastedText: string): string[] => {
  const sanitizedText = escape(pastedText);
  return sanitizedText
    .split(/\s*,\s*|\s+/)
    .map((element) => element.trim())
    .filter(Boolean);
};
